import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Response, Http} from '@angular/http';
import {_throw} from 'rxjs/observable/throw';
import {catchError, map, share} from 'rxjs/operators';
import {of} from 'rxjs/observable/of';
import {environment} from '../../environments/environment';

const parseJwt = (str: string) => {
    if (!str || !str.length)
        return {};
    var base64Url = str.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return JSON.parse(jsonPayload);
};

interface Tokens {
    accessToken: string,
    refreshToken: string,
    privateToken: string,
}

@Injectable()
export class AuthenticationService {

    private tokens: Tokens;
    private refreshingTokenObservable: Observable<Response>;

    // convenience
    private get at() {
        return this.tokens.accessToken;
    }

    constructor(
        private http: Http
    ) {
        this.readStorage();
    }

    private readStorage() {
        this.tokens = {
            accessToken: localStorage.getItem('accessToken'),
            refreshToken: localStorage.getItem('refreshToken'),
            privateToken: localStorage.getItem('privateToken')
        };
    }

    private setStorage(res: Response) {
        let b = res.json();
        localStorage.setItem('accessToken', b.accessToken);
        localStorage.setItem('refreshToken', b.refreshToken);
        localStorage.setItem('privateToken', b.privateToken);
        this.readStorage();
    }

    private isExpired() {
        let jwt = parseJwt(this.tokens.accessToken);
        return jwt && ((jwt.exp * 1000) < Date.now())
    }

    public isConnected() {
        return this.tokens && this.tokens.accessToken && this.tokens.accessToken.length
    }

    public get privateToken() {
        return this.tokens.privateToken;
    }

    public getJwtToken(): Observable<string> {
        if (this.isConnected()) {
            if (this.refreshingTokenObservable) {
                return this.refreshingTokenObservable
                    .pipe(
                        map(() => {
                            return this.at
                        })
                    )
            } else if (this.isExpired()) {
                this.refreshingTokenObservable = this.http
                    .post(environment.url + '/auth/refresh', {
                        accessToken: this.at,
                        refreshToken: this.tokens.refreshToken
                    })
                    .pipe(share());
                return this.refreshingTokenObservable.pipe(
                    map((res: Response) => {
                        this.refreshingTokenObservable = null;
                        this.setStorage(res);
                        return this.at
                    }),
                    catchError(err => {
                        this.logout();
                        return _throw(err)
                    })
                )
            } else {
                return of(this.at)
            }
        } else {
            this.logout();
            return null;
        }
    }

    public login(user: string, password: string): Observable<any> {
        return this.http
            .post(environment.url + '/auth/login', {
                login: user,
                password: password,
            })
            .pipe(
                map((res: Response) => {
                    this.setStorage(res)
                }))
    }

    public logout() {
        console.log('logout');
        this.tokens = null;
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('privateToken');
        this.refreshingTokenObservable = null;
        window.location.href = '/auth/login';
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/authentication/service/authentication.service.ts